import { render, staticRenderFns } from "./textStyleCtrl.vue?vue&type=template&id=1b621a02&scoped=true&"
import script from "./textStyleCtrl.vue?vue&type=script&lang=js&"
export * from "./textStyleCtrl.vue?vue&type=script&lang=js&"
import style0 from "./textStyleCtrl.vue?vue&type=style&index=0&id=1b621a02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b621a02",
  null
  
)

export default component.exports